import { FlowHookActions } from "./hook";

export class LoadCheckpointHook {
  actions: FlowHookActions;

  constructor(actions: FlowHookActions) {
    this.actions = actions;
  }

  execute() {
    this.actions.loadLastCheckpoint();
  }
}
